import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-filter",
  "use": "svgIcon-filter-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.41421\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-filter\"><path d=\"m0 0h21.369v21.369h-21.369z\" fill=\"none\" /><path d=\"m8.987 21.369v-9.886l-8.987-11.483h21.369l-8.887 11.483v8.089l-3.595 1.598\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol